import Instrument from "../Instrument";

class TR303 extends Instrument {

	constructor(path) {
		super("TR303", TR303.nice_name, path);

		this.createParameter("volume", {
			min: 0,
			max: 1,
			default: 0.8,
			step: 0.05
		});

		this.createParameter("decay", {
			min: 0,
			max: 1,
			default: 0.2,
			step: 0.05
		});

		this.createParameter("accent", {
			min: 0,
			max: 100,
			default: 60,
			step: 1
		});

		this.createParameter("envmod", {
			min: 0,
			max: 500,
			default: 200,
			step: 10
		});

		this.createParameter("cutoff", {
			min: 0,
			max: 9000,
			default: 4000,
			step: 10
		});

		this.createParameter("octave", {
			min: -1,
			max: 4,
			default: 1,
			step: 1,
			lock_step: true
		});

		this.createParameter("reso", {
			min: 0,
			max: 12,
			default: 4,
			step: 1
		});

		this.prevoius = false;
		this.prevoiusFreq = false;

	}

	scheduleNote(notes, time, tonic, scale, tempo) {

		var note = this.getPlayableNote(notes);
		var accent = notes.indexOf(12) !== -1;
		var slide = notes.indexOf(13) !== -1;

		if(note !== false) {
			var freq = this.getNoteFrequency(tonic, scale, this.getParameterByName('octave').value, note);

			this.gainParam.cancelScheduledValues(time);

			if(this.prevoius) {
				this.frequency.setValueAtTime(this.prevoiusFreq, time);
				this.frequency.linearRampToValueAtTime(freq, time + 0.0006);
			} else {
				this.gainParam.setValueAtTime(0.0001, time);
				this.frequency.setValueAtTime(freq, time);
				this.gainParam.linearRampToValueAtTime(this.getParameterByName('volume').value, time + 0.001);
			}

			if(!slide) {
				this.gainParam.setValueAtTime(this.getParameterByName('volume').value, time + 0.068);
				this.gainParam.linearRampToValueAtTime(0.0001, time + 0.069); //TODO 6e4 / tempo / 4 / 1000 / 6  * 3.5 + 0.001
			}

			if(!this.prevoius) {
				this.filter1.cancelScheduledValues(time);
				this.filter2.cancelScheduledValues(time);
				var d = this.getParameterByName('decay').value,
					y = this.getParameterByName('cutoff').value,
					h = this.getParameterByName('cutoff').value + this.getParameterByName('envmod').value;
				if(accent) {
					 var g = 2 * (this.getParameterByName('accent').value - 10) / 1000,
						 v = (100 - (d - 1)) / 5000;

					this.filter1.linearRampToValueAtTime(h + g, time);
					this.filter2.linearRampToValueAtTime(h + g, time);
					this.filter1.exponentialRampToValueAtTime(600, time + v);
					this.filter2.exponentialRampToValueAtTime(600, time + v);

				} else {
					this.filter1.setValueAtTime(h, time);
					this.filter2.setValueAtTime(h, time);
					this.filter1.linearRampToValueAtTime(y, time + d);
					this.filter2.linearRampToValueAtTime(y, time + d);
				}

			}

			this.prevoius = slide;
			this.prevoiusFreq = freq
		} else {
			this.prevoius = false;
		}





	}

	getNotesNames(tonic, key) {

		var notes = super.getNotesNames(tonic, key);

		notes[12] = "Accent";
		notes[13] = "Slide";

		return notes;

	}

	getPlayableNote(notes) {
		for(var i = notes.length - 1; i >= 0; i--) {
			if(notes[i] < 12) {
				return notes[i];
			}
		}
		return false;
	}

	createNodes(context) {
		var oscillator = context.createOscillator();

		oscillator.type = 'sawtooth';
		oscillator.start();

		var gainNode = context.createGain();

		gainNode.gain.value = 0;


		var filter1 = context.createBiquadFilter();

		filter1.type = "lowpass";
		filter1.frequency.value = 9e3;
		filter1.Q.value = 4.5;
		filter1.gain.value = -50;

		var filter2 = context.createBiquadFilter();

		filter2.type = "lowpass";
		filter2.frequency.value = 9e3;
		filter2.Q.value = 4.5;
		filter2.gain.value = -50;

		oscillator.connect(filter1);
		filter1.connect(filter2);
		filter2.connect(gainNode);

		this.gainParam = gainNode.gain;
		this.frequency = oscillator.frequency;
		this.filter1 = filter1.frequency;
		this.filter2 = filter2.frequency;


		this.getParameterByName('reso').setParam(filter2.Q);
		//this.getParameterByName('reso').setParam(filter2.Q);
		return {
			connect: (node) => {
				gainNode.connect(node);
			},
			disconnect: (node) => {
				gainNode.disconnect(node);
			}
		};

	}
}

TR303.nice_name = 'TR-303';

export default TR303;
